import { Product } from "src/app/api/models";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { RetrieveService } from "src/app/api/services";
import { ProductService } from "src/app/shared/services/product.service";
import { switchMap } from "rxjs/operators";
import { Observable } from "rxjs";

@Component({
  selector: "app-product-detail",
  templateUrl: "./product-detail.component.html",
  styleUrls: ["./product-detail.component.scss"],
})
export class ProductDetailComponent implements OnInit {
  private sub: any;
  product$: Observable<Product>;

  constructor(
    private route: ActivatedRoute,
    private retrieveService: RetrieveService,
    private productService: ProductService,
  ) {
  }

  ngOnInit() {
    this.product$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.retrieveService.getProduct({ product_id: parseInt(params.get('id')) })
        )
    );
  }

  addToCart(product: Product) {
    this.productService.addToCart(product);
  }
}
